import Link from 'next/link'
import parse from 'html-react-parser'
import { Section } from '@/components'
import { getTranslatedField } from '@/libs/utils'
import type { ArtworkType } from '@/@types/microcms-type'

export const Description = ({
    project,
    locale
}: {
    project: ArtworkType
    locale?: string
}) => {
    const { description, people, links, category } = project

    return (
        <Section className="lg:max-w-[68vw]">
            <div className="md:flex md:gap-[8vw] items-start">
                {(description?.description_ja !== undefined ||
                    description?.description_en !== undefined) && (
                    <div className="only-sm:mb-16 md:w-full md:shrink">
                        {parse(
                            getTranslatedField({ field: description, locale })
                        )}
                    </div>
                )}

                <div className="md:w-[200px] lg:w-[250px] md:shrink-0 [&_*]:text-v-sm [&_*]:leading-v-body grid grid-cols-1 gap-3 md:gap-5">
                    {people.length > 0 && (
                        <ul className="flex flex-wrap gap-x-4">
                            {people.map((person) => (
                                <li
                                    key={person.id}
                                    className="h-[1.5em] after:content-['/'] after:ml-4 last:after:hidden"
                                >
                                    <Link
                                        href={`/people/${person.id}`}
                                        scroll={false}
                                        className="text-v-sm md:hover:opacity-50 duration-[300ms]"
                                    >
                                        {getTranslatedField({
                                            field: person.name,
                                            locale
                                        })}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    )}
                    {category && category.length > 0 && (
                        <ul className="flex flex-wrap gap-x-4">
                            {category.map((cat, i) => (
                                <li
                                    key={`${cat.id}-${i}`}
                                    className="h-[1.5em] after:content-['/'] after:ml-4 last:after:hidden"
                                >
                                    {cat.name}
                                </li>
                            ))}
                        </ul>
                    )}
                    {links && links.length > 0 && (
                        <ul className="flex flex-wrap gap-x-4">
                            {links.map((link, i) => (
                                <li key={`${link.link_text}-${i}`}>
                                    <a
                                        href={link.external_link}
                                        className="underline underline-offset-[0.5em] decoration-v-gray-dark/60 after:content-['/'] after:ml-4 last:after:hidden break-all md:hover:opacity-50 duration-[300ms]"
                                    >
                                        {link.link_text}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </Section>
    )
}
